import { ChecklistItem } from './../../builders/checklist_item_builder';
import { IDelegateController, IDelegateConstant, IDelegateResponder } from 'ui-ng-delegate';
import { IChecklistItemStrategy } from './../../strategies/checklist_item_strategy';
import { Strategy } from 'utility-ts-strategy';
import { PromiseHash } from './../../services/promise_hash_factory';
import { ICommand } from 'core-ts-types';
import { IChecklistItem } from './../../types/checklist_types';

interface IChecklistScope extends ng.IScope {
  $ctrl: ChecklistController;
  items: IChecklistItem[];
}

class ChecklistController {
  private ITEM_TRANSITION_TIME = 5000;
  private promiseHash: PromiseHash;

  constructor(
    private $scope: IChecklistScope,
    private selectChecklistItemCommand: ICommand,
    private udpateChecklistItemStatusCommand: ICommand,
    private udpateChecklistItemStatusServerCommand: ICommand,
    private udpateChecklistItemStatusLocalCommand: ICommand,
    private ngChecklistItemStrategy: Strategy<IChecklistItemStrategy>,
    private ngPromiseHashFactory: typeof PromiseHash,
    private $timeout: ng.ITimeoutService
  ) {
    this.promiseHash = new this.ngPromiseHashFactory();

    this.$scope.$on('$destroy', () => {
      _.each(this.promiseHash.hash, (p) => {
        this.$timeout.cancel(p);
      });
    });
  }

  selectedItemChanged($event: any) {
    if ($event.detail.value === null) {
      return;
    }
    this.selectItem(this.$scope.items[$event.detail.value]);
  }

  selectItem(item: IChecklistItem) {
    return this.selectChecklistItemCommand(item);
  }

  setTimer(item: IChecklistItem) {
    let p: ng.IPromise<any>;
    const strategy = this.ngChecklistItemStrategy[item.status] as IChecklistItemStrategy;
    const transitionToStatus = strategy.transitionToStatus();
    const nextStrategy = this.ngChecklistItemStrategy[transitionToStatus] as IChecklistItemStrategy;
    const nextStatus = nextStrategy.transitionToStatus();

    this.udpateChecklistItemStatusServerCommand(item, nextStatus)
      .then(() => {
        this.udpateChecklistItemStatusLocalCommand(item, transitionToStatus);
        p = this.$timeout(() => {
          return this.udpateChecklistItemStatusLocalCommand(item, nextStatus);
        }, this.ITEM_TRANSITION_TIME);
        this.promiseHash.insert(p, item.id);
        return p;
      })
      .then(() => {
        this.$scope.$applyAsync(() => {
          if (!_.isEmpty(this.$scope.items)) {
            this.selectItem(_.first(this.$scope.items));
          }
        });
      })
      .catch(angular.noop);
  }

  cancelTimer(item: IChecklistItem) {
    const strategy = this.ngChecklistItemStrategy[item.status] as IChecklistItemStrategy;
    const cancelTransitionStatus = strategy.cancelTransitionStatus!();
    this.$timeout.cancel(this.promiseHash.remove(item.id));
    return this.udpateChecklistItemStatusCommand(item, cancelTransitionStatus);
  }
}

class ChecklistDelegate {
  constructor(DelegateController: IDelegateController, checklistDelegateConfiguration: IDelegateConstant) {
    DelegateController(this, checklistDelegateConfiguration);
  }
}

export interface IChecklistDelegate {
  setTimer: (item: ChecklistItem) => void;
  cancelTimer: (item: ChecklistItem) => void;
}

angular
  .module('capability-ng-checklist')
  .service('checklistDelegate', ChecklistDelegate)
  .constant('checklistDelegateConfiguration', {
    uniqueComponent: 'checklist',
    vocabulary: {
      setTimer: function(
        scope: IChecklistScope,
        el: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        evt: ng.IAngularEvent,
        item: ChecklistItem
      ) {
        scope.$ctrl.setTimer(item);
      },
      cancelTimer: function(
        scope: IChecklistScope,
        el: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        evt: ng.IAngularEvent,
        item: ChecklistItem
      ) {
        scope.$ctrl.cancelTimer(item);
      }
    }
  })
  .controller('ngChecklistController', ChecklistController)
  .directive('checklist', function(
    DelegateResponder: IDelegateResponder,
    checklistDelegateConfiguration: IDelegateConstant
  ) {
    return {
      templateUrl: 'lib/checklist/components/checklist/checklist.html',
      controller: 'ngChecklistController',
      controllerAs: '$ctrl',
      scope: {
        items: '<'
      },
      link: DelegateResponder(checklistDelegateConfiguration, function(scope, el, attrs) {})
    };
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/components/checklist/checklist.ts